export class MailStatusTransition {
  public id: number;
  public date: string; // ?($date - time)
  public mailId: number;
  public contactId?: number;
  public globalStatusId?: number;
  public specificStatusId?: number;
  public comment?: string;
}
